import React from 'react'
import { useNavigate } from 'react-router-dom';
import { CardBody, Table, TabPane } from "reactstrap";

const BulkSummary = ({ toggleArrowTab, activeArrowTab, leadSummary, files, isChecked, SelectedAssignLabelText, SelectedLabelText }) => {
  const navigate = useNavigate()
  const showSummary = () => {
    navigate("/leads")
  }
  return (
    <>
      <TabPane className="sn-lead-map-field-tble-top" id="steparrow-new-tab1" tabId={8}>
        <div>
          <CardBody>
            <div className="live-preview n-tble-home-page">
              <div className="table-responsive">
                <Table className="table-bordered align-middle table-nowrap mb-0">
                  <thead style={{ background: "#fff2f2" }}>
                    <tr>
                      {" "}
                      <th scope="col">Title</th>
                      <th scope="col">Fields in File</th>
                    </tr>
                  </thead>
                  <tbody className="sn-bulk-summary-table-main">
                    <tr>
                      <td className="fw-semibold">Selected File</td>
                      <td>
                        <p>{files?.name}</p>
                      </td>
                    </tr>
                    {/* <tr>
                      <td className="fw-semibold">Share Lead with</td>
                      <td>
                        <p>As per csv</p>
                      </td>
                    </tr> */}
                    <tr>
                      <td className="fw-semibold">Invalid rows</td>
                      <td>
                        <p>{leadSummary?.data?.skip?.length > 1 ? leadSummary?.data?.skip?.length : 0}</p>
                        {/* rows (which will be skipped) */}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">Inserted rows</td>
                      <td>
                        <p>{leadSummary?.data?.insertedCount}</p>
                        {/* rows (which will be skipped) */}
                      </td>
                    </tr>
                    <tr>
                      <td className="fw-semibold">
                        Handling duplicates Lead records
                      </td>
                      <td>
                        {/* <p>Update empty fields of duplicates</p> */}
                        <p>{leadSummary?.data?.overWriteCount}</p>
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-semibold">Handling duplicate To options</td>
                      <td>
                        <p>{SelectedLabelText}</p>
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-semibold">Handling Assign To options</td>
                      <td>
                        <p>{SelectedAssignLabelText}</p>
                      </td>
                    </tr>
                    {/* <tr>
                      <td className="fw-semibold">Tag option</td>
                      <td>
                        <p>Keep Existing and Add New Tags</p>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td className="fw-semibold">Tags</td>
                      <td>
                        <button type="button" className="btn btn-sm btn-light">
                          No Lead tags
                        </button>
                      </td>
                    </tr> */}
                    <tr>
                      <td className="fw-semibold">
                        Map Available Call Logs Of Leads
                      </td>
                      <td>{isChecked === true ? 'true' : 'false'}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </div>
          </CardBody>
        </div>
        <div className="d-flex gap-3 mt-4 justify-content-end">
          <div className="sn-bulk-next-back-btn margin-auto me-3">
            <button
              type="button"
              className="btn btn-light btn-label previestab"
              onClick={() => {
                toggleArrowTab(activeArrowTab - 1);
              }}
            >
              <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i> Back
            </button>
            <button
              type="button"
              className="btn btn-danger btn-label right ms-auto nexttab nexttab"
              onClick={() => showSummary()}
            >
              <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
              Show
            </button>
          </div>
        </div>
      </TabPane>
    </>
  )
}

export default BulkSummary
